// TODO: Why are we importing random types?
import { IScoringRules } from "@scaleip/nest-api/src/common/types/contacts.type";
import { Form, Formik } from "formik";
import React from "react";

import { Box, Button, FormControl, FormLabel, Slider, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

import { sortNestedObject } from "@components/Admin/helpers";

interface IScoringFormValues {
  label: string;
  name: string;
  setFieldValue: (name: string, value: number | number[]) => void;
  value: number;
}

const SliderField = ({ label, name, setFieldValue, value }: IScoringFormValues) => {
  return (
    <FormControl fullWidth margin="normal">
      <FormLabel>
        {label} - <b>{value}</b>
      </FormLabel>
      <Slider
        max={100}
        min={0}
        onChange={(_, newValue) => setFieldValue(name, newValue)}
        step={1}
        value={value}
        valueLabelDisplay="auto"
      />
    </FormControl>
  );
};

interface IScoringForm {
  handleUpdateScoringRules: (newScoringRules: IScoringRules) => void;
  isUpdatingScoringRules: boolean;
  scoringRules: IScoringRules;
}

const ScoringForm = ({ handleUpdateScoringRules, isUpdatingScoringRules, scoringRules }: IScoringForm) => {
  const sortedRules = sortNestedObject(scoringRules);

  return (
    <Box
      sx={{
        backgroundColor: "white",
        padding: 4,
      }}
    >
      <Formik
        initialValues={{
          attendedConference: {
            hasAutm2023: scoringRules.attendedConference.hasAutm2023,
            hasAutm2024: scoringRules.attendedConference.hasAutm2024,
            hasBio2022: scoringRules.attendedConference.hasBio2022,
            hasBio2023: scoringRules.attendedConference.hasBio2023,
            hasBio2024: scoringRules.attendedConference.hasBio2024,
            hasLes2023: scoringRules.attendedConference.hasLes2023,
            hasUidpHbcu2023: scoringRules.attendedConference.hasUidpHbcu2023,
            hasUidpMim2023: scoringRules.attendedConference.hasUidpMim2023,
          },
          emailStatus: {
            extrapolated: scoringRules.emailStatus.extrapolated,
            unavailable: scoringRules.emailStatus.unavailable,
            verified: scoringRules.emailStatus.verified,
          },
          scoreThreshold: scoringRules.scoreThreshold,
          seniority: {
            "C-suite": scoringRules.seniority["C-suite"],
            Director: scoringRules.seniority.Director,
            Entry: scoringRules.seniority.Entry,
            Manager: scoringRules.seniority.Manager,
            Senior: scoringRules.seniority.Senior,
          },
          titleScore: {
            common: scoringRules.titleScore.common,
            middle: scoringRules.titleScore.middle,
            other: scoringRules.titleScore.other,
            rare: scoringRules.titleScore.rare,
          },
        }}
        onSubmit={(values) => {
          handleUpdateScoringRules(values);
        }}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <Box sx={{ margin: "0 auto", maxWidth: 600 }}>
              <Typography gutterBottom variant="h4">
                Scoring Rules
              </Typography>
              <Box
                sx={{
                  mb: 2,
                }}
              >
                <Typography variant="h6">Seniority</Typography>
                {Object.keys(sortedRules.seniority).map((key) => (
                  <SliderField
                    key={key}
                    label={`Seniority - ${key}`}
                    name={`seniority.${key}`}
                    setFieldValue={setFieldValue}
                    value={values.seniority[key as keyof typeof values.seniority]}
                  />
                ))}
              </Box>

              <Box
                sx={{
                  mb: 2,
                }}
              >
                <Typography variant="h6">Email Status</Typography>
                {Object.keys(sortedRules.emailStatus).map((key) => (
                  <SliderField
                    key={key}
                    label={`Email Status - ${key}`}
                    name={`emailStatus.${key}`}
                    setFieldValue={setFieldValue}
                    value={values.emailStatus[key as keyof typeof values.emailStatus]}
                  />
                ))}
              </Box>

              <Box
                sx={{
                  mb: 2,
                }}
              >
                <Typography variant="h6">Title Score</Typography>
                {Object.keys(sortedRules.titleScore).map((key) => (
                  <SliderField
                    key={key}
                    label={`Title Score - ${key}`}
                    name={`titleScore.${key}`}
                    setFieldValue={setFieldValue}
                    value={values.titleScore[key as keyof typeof values.titleScore]}
                  />
                ))}
              </Box>

              <Box
                sx={{
                  mb: 2,
                }}
              >
                <Typography variant="h6">Attended Conference</Typography>
                {Object.keys(sortedRules.attendedConference).map((key) => (
                  <SliderField
                    key={key}
                    label={`Attended Conference - ${key}`}
                    name={`attendedConference.${key}`}
                    setFieldValue={setFieldValue}
                    value={values.attendedConference[key as keyof typeof values.attendedConference]}
                  />
                ))}
              </Box>

              <Box
                sx={{
                  mb: 2,
                }}
              >
                <Typography variant="h6">Score Threshold</Typography>
                <SliderField
                  label={`Score Threshold`}
                  name={`scoreThreshold`}
                  setFieldValue={setFieldValue}
                  value={values.scoreThreshold}
                />
              </Box>

              <Box mt={4}>
                <Button color="primary" disabled={isUpdatingScoringRules} fullWidth type="submit" variant="contained">
                  {isUpdatingScoringRules ? (
                    <>
                      Saving
                      <CircularProgress
                        size={20}
                        sx={{
                          color: "white",
                          ml: 2,
                        }}
                      />
                    </>
                  ) : (
                    "Save"
                  )}
                </Button>
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default ScoringForm;
